import { useMutation, useQueryClient } from '@tanstack/react-query';
import { estimateHeadersService } from '../services/estimateHeaders.service';
import type { EstimateCreateInput } from '../types/estimate.types';

export function useCreateEstimate() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (input: EstimateCreateInput) => estimateHeadersService.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['estimates'] });
    },
  });

  return {
    createEstimate: mutation.mutateAsync,
    isCreating: mutation.isPending,
    error: mutation.error as Error | null,
  };
}
